import React, { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet'
import { useErrorService } from '@abroad/components'
import Imgix from 'react-imgix'
import {
  PageHeader,
  QuestsCard,
  SwiperSlideQuests,
  SwiperSlideQuestsHighlights,
} from '../components'
import { useResolutionService } from '../hooks'
import API from '../utils/API'
import { CustomShimmerContentBlock } from '../components/common'

const Quests = () => {
  const { isMDScreen } = useResolutionService()
  const Error = useErrorService()
  const [isLoading, setIsLoading] = useState(true)
  const [upcomingQuests, setUpcomingQuests] = useState([])

  useEffect(() => {
    const getUpcoming = async () => {
      setIsLoading(true)
      try {
        const { data } = await API.quests.upcomingQuests()
        setUpcomingQuests(data)
        setIsLoading(false)
      } catch (e) {
        Error.showError(e)
        setIsLoading(false)
      }
    }
    getUpcoming()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <Helmet>
        <title>{'Experiences | Abroad'}</title>
        <meta name='title' content={'Quests | Abroad'}></meta>
        <meta property='og:title' content={'Quests | Abroad'}></meta>
        <meta property='twitter:title' content={'Quests | Abroad'}></meta>
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/quests`}></link>
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/quests`}></meta>
      </Helmet>

      <main>
        <PageHeader title='Experiences' />
        <div>
          <div>
            <Imgix
              className='border-radius-10 mt-32px lazyload imgix-object-cover'
              imgixParams={{
                fit: 'crop',
                crop: 'edges',
                ar: isMDScreen ? '2:1' : '5:2',
              }}
              src={`${process.env.REACT_APP_IMG_SOURCE}/StaticQuestMain.png`}
              width={'100%'}
              alt='image'
              attributeConfig={{
                src: 'data-src',
                srcSet: 'data-srcset',
                sizes: 'data-sizes',
              }}
              htmlAttributes={{
                src: `${
                  process.env.REACT_APP_IMG_SOURCE
                }/StaticQuestMain.png?ar=${
                  isMDScreen ? '2:1' : '5:2'
                }&fit=crop&crop=edges&fill=blur&blur=300&px=16&auto=format`, // low quality image here
              }}
            />
            <h3 className='s1 mt-24px tracking-normal'>
              Wisdom-Based Experiences to Reconnect with What Matters
            </h3>
            <p className='pt-16px s5' style={{ lineHeight: '1.875rem' }}>
              In a fast-paced world, it’s easy to lose touch with what truly
              matters. Abroad’s wisdom-based experiences create space for
              reflection, renewal, and reconnection—with yourself, your purpose,
              and the natural world.
              <br />
              <br />
              Grounded in neuroscience, timeless wisdom, and measurable impact,
              these experiences, guided by our faculty, coaches, and indigenous
              wisdom keepers, foster lasting growth and empower you toward a
              life of true prosperity.
            </p>
          </div>
          <div>
            <h1 className='mt-52px s3 mb-0'>How Abroad Experiences Work</h1>
            <SwiperSlideQuests />
          </div>
          <div>
            <h1 className='mt-52px s3 mb-0'>
              What Makes Abroad Experiences Unique
            </h1>
            <SwiperSlideQuestsHighlights />
          </div>
          <div>
            {isLoading ? (
              <div className='mt-40px'>
                <CustomShimmerContentBlock />
              </div>
            ) : (
              <>
                {upcomingQuests.length === 0 ? null : (
                  <>
                    <h1 className='mt-52px s3 mb-0'>
                      Open Enrollment Experiences{' '}
                    </h1>
                    <p className='s5 mt-3 mb-4'>
                      Explore transformative journeys available to the broader
                      Abroad community.
                    </p>
                  </>
                )}
                {upcomingQuests.map((item) => (
                  <QuestsCard item={item} />
                ))}
              </>
            )}
          </div>
          <div className='mt-32px bg-abroad-blue w-100 py-3 px-lg-5 text-center rounded'>
            <h1 className='s4 text-white'>
              Interested in a Custom Experience?
            </h1>
            <p className='text-white mt-2 s7'>
              If you lead a community or network and would like to co-create a
              custom program, we’d love to hear from you. Let’s design something
              meaningful, together.
            </p>
          </div>
        </div>
      </main>
    </>
  )
}

export default Quests
